import React from 'react'
import SupportTicketContainer from '../../Component/SupportTickets/SupportTicketContainer'

const SupportTicket = () => {
  return (
    <div className='page-body'>
      <SupportTicketContainer/>
    </div>
   
  )
}

export default SupportTicket